import React from 'react';
import { Link } from 'react-router-dom';
import Button from '../../UI/Button/Button';

const jobsItem = props => (
    <div className={"jobItem" + (props.jobsIdsVisited && props.jobsIdsVisited.includes(props.id) ? ' visited' : '' )}>
        <p className="fw-800">{props.title}</p>
        {props.link ? 
            <Link to={props.link}>
                <Button clicked={props.clicked} btnClasses={'m-0  wh-35 h5 fw-600 text-uppercase'}>+</Button>
            </Link>
        :   <Button clicked={props.clicked} btnClasses={'m-0  wh-35 h5 fw-600 text-uppercase'}>+</Button>}
    </div>
);

export default jobsItem;